import React, { forwardRef, useEffect, useRef } from 'react';
import './_summernote.scss';
import './_summernote.dark-mode.scss';
import '../CodeMirror/_codemirror.dark.mode.scss';

import $ from 'jquery';
import PropTypes from 'prop-types';
import { processHtml, revertHtml } from './helpers';
import { IS_LOCAL } from '../../utils/config';

import '../../services/libs/summernote.lib'

import 'codemirror/lib/codemirror'
import 'codemirror/mode/xml/xml'
import 'codemirror/mode/htmlmixed/htmlmixed'

import 'bootstrap/js/modal';
import 'bootstrap/js/dropdown';
import 'bootstrap/js/tooltip';

// Тест для опредленных доменов
const htmlParsesDomains = ['socialmediamarketplace.com', 'ads4u.co', 'panel.perfectpanel.dev']
export const htmlParsesDomainsWithSu = htmlParsesDomains.flatMap((domain) => {
  const base = domain.split('.')[0];
  return [domain, `${base}.mypanel.link`];
});

const Summernote = forwardRef((props, ref) => {
  const node = ref || useRef(null)
  const { value, options, name, onChange } = props;

  useEffect(() => {
    const newOptions = { ...options };
    if (options?.htmlParser) {
      if (htmlParsesDomainsWithSu.includes(window?.location?.host) || IS_LOCAL) {
        newOptions.onActiveCodeView = (content) => revertHtml(content);
        newOptions.onDeactivateCodeView = (content) => processHtml(content)
      }
    }

    $(node.current).summernote({
      ...newOptions,
      theme: 'default',
      callbacks: {
        onChange(contents) {
          if (options?.checkEmpty && ['<p><br></p>', '<br>'].includes(contents)) {
            onChange('');
            return;
          }
          if (onChange) {
            $(node.current).summernote('editor.saveRange');
            onChange(contents)
          }
          if (
            contents.indexOf('class="shorthr"') === -1
            && $(this).next().find('.btn-shorthr-disabled').length
          ) {
            $(this).next().find('.btn-shorthr-disabled').removeClass('btn-shorthr-disabled');
          }
        },
      },
    })

    /**
     * Правка https://app.clickup.com/t/24329429/FR-119
     * Баг модалка в модалке
     */
    $(document).on('hidden.bs.modal', () => {
      if ($('.modal:visible').length) {
        $('body').addClass('modal-open');
      }
    });

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      $(node.current).summernote('destroy');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="summernote-container">
      <div className="cm-s-default">
        <textarea ref={node} defaultValue={value} name={name} />
      </div>
    </div>
  )
})

Summernote.defaultProps = {
  options: {
    placeholder: 'Content',
    height: 120,
    toolbar: [
      ['style', ['style']],
      ['font', ['bold', 'underline', 'clear']],
      ['color', ['color']],
      ['para', ['ul', 'ol', 'paragraph']],
      ['table', ['table']],
      ['insert', ['link', 'picture', 'video']],
      ['view', ['fullscreen', 'codeview', 'help']],
    ],
  },
}

Summernote.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.object,
  onChange: PropTypes.func,
};

export default Summernote;
